import axios from "axios";
import { useState } from "react";
import { API_URL, IndexDbStoreName, IndexedDbName } from "../zustand/const";
import { IndexedDBUtility } from "../util/IndexedDb";
import { isEmpty } from "underscore";
import { Notify } from "notiflix";

export const useFileUpload = ({ chatMode = true }) => {
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState([]);
  const [error, setError] = useState(null);

  const uploadFile = async (data, index) => {
    try {
      if (!data) {
        return;
      };
      setIsUploading(true);
      setError(null);
      const { file, type } = data;
      const fd = new FormData();
      fd.append('file', file);

      let db = new IndexedDBUtility(IndexedDbName, IndexDbStoreName);
      await db.openDatabase();
      const token = await db.readFromDatabase('jwt');
      if (isEmpty(token)) {
        Notify.failure('Please login to upload file');
        return;
      }
      const { jwt } = token;

      let res = await axios.post(`${API_URL}/file`, fd, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setUploadProgress((prev) => {
            const newProgress = [...prev];
            newProgress[index] = percentCompleted;
            return newProgress;
          });
        },
      }).finally(() => {
        setUploadProgress((prev) => {
          const newProgress = [...prev];
          newProgress[index] = 0;
          return newProgress;
        });
        setIsUploading(false);
      });
      if (!res.data) {
        throw new Error('Invalid response');
      }
      const { data: response } = res.data

      // console.log(response);
      const { original_name, id, file_type, file_size, file_path } = response
      return {
        id,
        name: original_name,
        size: file_size,
        type: type,
        mime: file_type,
        url: file_path,
      };
    } catch (error) {
      setError(error);
      console.error(error);
    } finally {
      setIsUploading(false);
    }
  };
  return { uploadFile, isUploading, uploadProgress, error };
};
